import i18n from '@/utils/i18n';
import moment from 'moment';
import React from 'react';
import { formatShortDate, formatTime } from '@/utils/date';
import { StyleSheet, Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  deliveredAt: string;
}

export const OrderDeliveredAt: React.FC<Props> = ({ deliveredAt }) => {
  const deliveredAtMoment = moment(deliveredAt);

  return (
    <Text numberOfLines={2} style={[TYPOGRAPHY.small, styles.deliveredAt]}>
      {i18n.t('delivered_on_at', {
        date: formatShortDate(deliveredAtMoment),
        time: formatTime(deliveredAtMoment),
      })}
    </Text>
  );
};

const styles = StyleSheet.create({
  deliveredAt: {
    marginTop: 8,
  },
});
